import { UserLayout, TabLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'

import onlineCommons from '@jeecg/antd-online-mini'

/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [
  // {
  //   path: '/',
  //   name: 'dashboard',
  //   component: TabLayout,
  //   meta: { title: '工作台' },
  //   redirect: '/dashboard/analysis',
  //   children: [

  //   ]
  // },

  {
    path: '*',
    redirect: '/404',
    hidden: true
  },
  {
    path: '/online/singlereport/1534578016330522625',
    component: onlineCommons.OnlCgreportAutoList
  }
]

export const detailRouter = [
  {
    path: '/fusion',
    name: 'DataFusion',
    component: 'layouts/Router',
    meta: { title: '数据通融' },
    redirect: '/fusion/spareParts',
    children: [
      // 供水流域
      {
        path: '/fusion/spareParts',
        name: 'FusionSpareParts',
        component: 'fusion/components/SpareParts',
        meta: { title: '备品备件详情' }
      },
      {
        path: '/fusion/Model',
        name: 'FusionModel',
        component: 'fusion/components/Model',
        meta: { title: '设备型号详情' }
      },
      {
        path: '/fusion/manufacturers',
        name: 'FusionManufacturers',
        component: 'fusion/components/Manufacturers',
        meta: { title: '生产厂家详情' }
      },
      {
        path: '/fusion/process',
        name: 'FusionProcess',
        component: 'fusion/components/Process',
        meta: { title: '供水流域详情' }
      },
      {
        path: '/fusion/person',
        name: 'FusionPerson',
        component: 'fusion/components/Person',
        meta: { title: '人员详情' }
      }
    ]
  }
]
/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/register/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/register/RegisterResult')
      },
      {
        path: 'alteration',
        name: 'alteration',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/alteration/Alteration')
      }
    ]
  },
  {
    // OAuth2 APP页面路由
    path: '/oauth2-app',
    component: BlankLayout,
    redirect: '/oauth2-app/login',
    children: [
      {
        // OAuth2 登录路由
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "oauth2-app.login" */ '@/views/user/oauth2/OAuth2Login')
      }
    ]
  },

  {
    path: '/test',
    component: BlankLayout,
    redirect: '/test/home',
    children: [
      {
        path: 'home',
        name: 'TestHome',
        component: () => import('@/views/Home')
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '/online/singlereport',
    component: onlineCommons.OnlCgreportAutoList
  },
  {
    path: '/dev/detail',
    component: () => import('@/views/equipment/account/modules/DeviceDetail.vue')
  },
  {
    path: '/filererpot',
    component: () => import('@/views/jeecg/report/online/FileReport.vue')
  }
]
